/**
 * Client-side auth + permission helper.
 *
 * The `admin` payload stored at login carries `role` and a full `permissions` matrix
 * (see the API's LoginController). These drive which menu items, routes and dashboard
 * controls are shown. This is CONVENIENCE ONLY — the server enforces every permission
 * independently via check_permission, so a tampered localStorage buys nothing but a
 * different set of visible buttons that still fail server-side.
 */
class Auth {
    isLoggedIn() {
        return !!localStorage.getItem('authToken');
    }

    admin() {
        try {
            return JSON.parse(localStorage.getItem('admin')) || {};
        } catch (e) {
            return {};
        }
    }

    role() {
        return this.admin().role || null;
    }

    isSuperAdmin() {
        return this.role() === 'admin';
    }

    permissions() {
        return this.admin().permissions || {};
    }

    /**
     * can('results', 'write') — Super Admin always true; everyone else checks the matrix.
     * Defaults action to 'read'. Fails closed for unknown modules.
     */
    can(moduleKey, action = 'read') {
        if (this.isSuperAdmin()) return true;
        const perms = this.permissions();
        return !!(perms[moduleKey] && perms[moduleKey][action] === true);
    }

    /* True if the user may see the module at all (any of its actions is granted). */
    canSee(moduleKey) {
        if (this.isSuperAdmin()) return true;
        const p = this.permissions()[moduleKey];
        return !!(p && (p.read || p.write || p.delete));
    }
}
export default new Auth();
